/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type View = "ADD_EMAIL_ADDRESS" | "CREATE_PASSWORD" | "CREATE_USERNAME" | "FORGOT_PASSWORD" | "LINK_ACCOUNT" | "SIGN_IN" | "SIGN_UP" | "%future added value";
export type AccountCompletionContainerLocal = {
    readonly accessToken: string | null;
    readonly view: View;
    readonly duplicateEmail: string | null;
    readonly " $refType": "AccountCompletionContainerLocal";
};
export type AccountCompletionContainerLocal$data = AccountCompletionContainerLocal;
export type AccountCompletionContainerLocal$key = {
    readonly " $data"?: AccountCompletionContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountCompletionContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountCompletionContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "view",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicateEmail",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '12b6cb73def9ad067562a9f942df15af';
export default node;
